import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ItemFilterModel } from 'src/app/models/filters/item-filter.model';
import { RemissionDetailModel } from 'src/app/models/rental/remission-detail';
import { RemissionDetailFromOrderModel } from 'src/app/models/rental/remission-detail-from-order.model';
import { RentalStockModel } from 'src/app/models/rental/rental-stock-response.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { FilterGlobalResponseModel } from 'src/app/models/responses/filter-global-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { MassiveOrderSelectionTableModel } from 'src/app/models/tables/preliminaries/massive-order-selection-table.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RemissionFromOrderService {

  constructor(private _httpClient: HttpClient) { }

  createManualOrder(remissionDetailContract: RemissionDetailModel): Observable<RemissionDetailModel> {
    return this._httpClient.post<RemissionDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionFromOrder.CreateManualOrderAsync}`,
      remissionDetailContract
    );
  }

  processManualOrder(remissionDetailContracts: RemissionDetailModel[]): Observable<boolean> {
    return this._httpClient.post<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionFromOrder.ProcessManualOrderAsync}`,
      remissionDetailContracts
    );
  }

  createMassiveOrder(remissionDetails: RemissionDetailModel[], orderId: number): Observable<boolean> {
    const params = new HttpParams().set('orderId', orderId);
    return this._httpClient.post<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionFromOrder.CreateMassiveOrderAsync}`,
      remissionDetails, { params: params }
    );
  }

  exportRemissionFromOrderConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean, state: number, origin: number): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString()).set('state', state).set('origin', origin);
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionFromOrder.ExportRemissionFromOrderConsultation}`, filters, {
      params, responseType: 'blob'
    });
  }

  getAllRemissionFromOrderWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, state: number, origin: number, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant).set('state', state).set('origin', origin);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionFromOrder.GetAllRemissionFromOrderWithPagination}`,
      filters, { params: params }
    );
  }

  getColumnsArticle(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionFromOrder.GetColumnsArticleAsync}`);
  }

  getColumnsForRemissionFromOrderConsultation(): Observable<FilterGlobalResponseModel> {
    return this._httpClient.get<FilterGlobalResponseModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionFromOrder.GetColumnsForRemissionFromOrderConsultation}`);
  }

  getColumnsStoresStock(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionFromOrder.GetColumnsStoresStockAsync}`);
  }

  getColumnsForMassiveOrderSelection(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionFromOrder.GetColumnsForMassiveOrderSelectionAsync}`);
  }

  getColumnsForMassiveOrderDetailSelection(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionFromOrder.GetColumnsForMassiveOrderDetailSelectionAsync}`);
  }

  getMassiveOrderForSelection(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[], remissionId: number): Observable<PagedResponseModel<MassiveOrderSelectionTableModel>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant).set('remissionId', remissionId);
    return this._httpClient.post<PagedResponseModel<MassiveOrderSelectionTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionFromOrder.GetMassiveOrderForSelectionAsync}`,
      filters, { params: params }
    );
  }

  getMassiveOrderDetailForSelection(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[], orderId: number): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant).set('orderId', orderId);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionFromOrder.GetMassiveOrderDetailForSelectionAsync}`,
      filters, { params: params }
    );
  }

  getOrderArticlesStockForSelection(branchId: number, costCenterId: number, remissionId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('branchId', branchId).set('costCenterId', costCenterId).set('remissionId', remissionId).set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionFromOrder.GetOrderArticlesStockForSelectionAsync}`,
      filters, { params: params }
    );
  }

  getOrderDetailsForRemission(branchId: number, costCenterId: number, remissionId: number): Observable<Array<RentalStockModel>> {
    return this._httpClient.get<Array<RentalStockModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionFromOrder.GetOrderDetailsForRemission}/${branchId}/${costCenterId}/${remissionId}`);
  }

  getRemissionDetailByOrder(itemFilters: Array<ItemFilterModel>): Observable<RemissionDetailModel> {
    return this._httpClient.post<RemissionDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionFromOrder.GetRemissionDetailByOrder}`,
      itemFilters);
  }

  getRemissionFromOrderDetailById(remissionId: number, remissionDetailId: number, articleId: number): Observable<RemissionDetailFromOrderModel> {
    const params = new HttpParams().set('remissionId', remissionId).set('remissionDetailId', remissionDetailId).set('articleId', articleId);
    return this._httpClient.get<RemissionDetailFromOrderModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionFromOrder.GetRemissionFromOrderDetailById}`,
      { params: params }
    );
  }

  getRemissionDetailByOrderKeys(remissionId: number, storeId: number, articleId: number, orderDetailId: number): Observable<RemissionDetailFromOrderModel> {
    const params = new HttpParams().set('remissionId', remissionId).set('storeId', storeId).set('articleId', articleId).set('orderDetailId', orderDetailId);
    return this._httpClient.get<RemissionDetailFromOrderModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionFromOrder.GetRemissionDetailByOrderKeysAsync}`,
      { params: params }
    );
  }

  getStoreStockByArticleForSelection(remissionId: number, orderDetailId: number, articleId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('remissionId', remissionId).set('orderDetailId', orderDetailId).set('articleId', articleId).set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionFromOrder.GetStoreStockByArticleForSelectionAsync}`,
      filters, { params: params }
    );
  }

  saveRemisionDetail(rentalStockModel: RentalStockModel): Observable<RemissionDetailModel> {
    return this._httpClient.post<RemissionDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionFromOrder.SaveRemisionDetail}`,
      rentalStockModel);
  }

  updateManualOrder(remissionDetailContract: RemissionDetailModel): Observable<RemissionDetailModel> {
    return this._httpClient.put<RemissionDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionFromOrder.UpdateManualOrderAsync}`,
      remissionDetailContract
    );
  }
}
